// © Microsoft Corporation. All rights reserved.

import { DesignSystem, accentFillActive, isDarkMode, neutralFillStealthHover } from "@microsoft/fast-components-styles-msft";
import {
    commentVPadding,
    mainLineHeight
} from "../../utils/commonJssConstants";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

export const ReplyListStyles = (config: DesignSystem) => ({
    replyListContainer: {
        margin: "4px 0 0",
        "padding-top": "4px",
        "& .cwt-commenting-disabled-container": {
            width: "100%",
            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "0"
        },
        "& .cwt-show-replies-btn": {
            display: "inline-flex",
            margin: "-4px",
            padding: "4px",
            "font-size": "13px",
            "font-weight": "500",
            color: isDarkMode(config) ? "#5CB6FF" : accentFillActive,
            fill: "currentColor",
            opacity: "1",
            "border-radius": "4px",

            "&:hover": {
                background: neutralFillStealthHover
            },

            "&.cwt-specific-comment-mode": {
                "margin-top": "20px"
            },

            "& .cwt-icon-label": {
                color: isDarkMode(config) ? "#5CB6FF" : accentFillActive
            }
        },

        "& .cwt-list": {
            padding: "0",
            margin: "0",

            "& .cwt-comment-form": {
                margin: commentVPadding + " 0 0"
            },

            "& > li": {
                padding: commentVPadding + " 0",
                margin: "0 0 -1px",

                "&:first-child": {
                    "padding-top": commentVPadding
                },
                "&:last-child": {
                    "padding-bottom": "0"
                },

                "& .cwt-comment-content": {
                    "& .cwt-avatar": {
                        "margin-top": "0"
                    },
                    "& .cwt-message": {
                        [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "1px",
                        padding: "inherit",
                        "font-size": "inherit",
                        "line-height": mainLineHeight,
                        background: "inherit",
                        border: "inherit"
                    },
                    "& .cwt-footer": {
                        [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "0"
                    }
                }
            }
        }
    }
});